import { Refresh as RefreshIcon } from "@mui/icons-material";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";

interface RefreshInfoButtonProps {
  onClick: () => void;
  lastRefreshedAt: Date;
  isFetching: boolean;
}

const RefreshInfoButton = ({
  onClick,
  lastRefreshedAt,
  isFetching,
}: RefreshInfoButtonProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        Updated: {lastRefreshedAt.toLocaleTimeString()}
      </Typography>
      <Tooltip title="Refresh active jobs">
        <IconButton onClick={onClick} loading={isFetching} size="small">
          <RefreshIcon
            fontSize="small"
            sx={{ visibility: isFetching ? "hidden" : "visible" }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default RefreshInfoButton;
